// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unvergessen-nav-bar-icon{background-color:#fff;margin:7px;-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 4px 8px 0 rgba(0,0,0,.19);box-shadow:0 4px 8px 0 rgba(0,0,0,.2),0 4px 8px 0 rgba(0,0,0,.19)}.unvergessen-nav-bar-icon:hover{background-color:#e0e0e0;-webkit-transition:.3s;transition:.3s}", ""]);
// Exports
module.exports = exports;
